
export default {
  /* tslint:disable */
  render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._t("default",function(){return [_c('div',{staticClass:"ae-form-paragraph",style:(_vm.paragraphStyle),attrs:{"data-ae-paragraph-type":_vm.type,"data-ae-paragraph-key":_vm.paragraph && _vm.paragraph.key}},[_vm._t("debug",null,{"items":_vm.items,"type":_vm.type}),_vm._v(" "),_vm._t("all",function(){return [_vm._l((_vm.items),function(item){return [(item.type === 'FIELD')?_vm._t("field",function(){return [(item.isVisible)?_c('ae-form-field',{key:item.key,style:(_vm.getItemStyle(item)),attrs:{"field":item,"document":_vm.document,"form":_vm.form,"placeholder":item.placeholder,"params":item.controlParams,"theme":_vm.theme,"readonly":_vm.readonly || item.isReadonly,"field-validation-errors":_vm.fieldValidationErrors}}):_vm._e()]},{"field":item,"document":_vm.document,"form":_vm.form}):(item.type === 'STANDALONE_CONTROL')?_vm._t("control",function(){return [(item.isVisible)?_c('ae-control',{key:item.key,class:item.classes,style:(_vm.getItemStyle(item)),attrs:{"readonly":_vm.readonly || item.isReadonly,"name":item.name,"document":_vm.document,"form":_vm.form,"placeholder":item.placeholder,"params":item.parameters,"theme":_vm.theme}}):_vm._e()]},{"control":item,"document":_vm.document,"form":_vm.form}):(item.type === 'TEXT')?_vm._t("text",function(){return [_c('div',{key:item.key,staticClass:"ae-form-text",style:(_vm.getTextStyle(item)),attrs:{"data-ae-form-text":""},domProps:{"innerHTML":_vm._s(item.html)}})]},{"text":item,"document":_vm.document,"form":_vm.form}):_vm._t("unknown",function(){return [_c('span',{key:item.key,staticClass:"ae-dev-error ae-dev-error--warn"},[_vm._v("\n                  unknown item type "),_c('pre',[_vm._v(_vm._s(item.type))]),_vm._v("in paragraph.\n          ")])]})]})]},{"items":_vm.items,"type":_vm.type,"document":_vm.document,"form":_vm.form}),_vm._v(" "),(_vm.freeFlexWeight > 0)?_c('div',{staticClass:"ae-form-flex-spacer",style:(_vm.freeFlexSpacerStyle),attrs:{"aria-hidden":"true","data-ae-form-flex-spacer":""}}):_vm._e()],2)]},{"items":_vm.items,"type":_vm.type,"document":_vm.document,"form":_vm.form})},
  staticRenderFns: [],
  /* tslint:enable */
  
  // inject: ['getAeppicContext'],
  props: {
    paragraph: Object, // TODO: Also allow id and index into form
    document: Object, // Must be an editable document
    // TODO: Also allow documentId: String 
    form: {
      type: Object,
      default: null
    },
    theme: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
    itemStyle: {
      type: Object,
      default: null,
    },
    fieldValidationErrors: {
      type: Object,
      default: () => ({}),
    }
    // TODO: add theme
  },
  data() {
    return {
    }
  },
  methods: {
    getItemStyle(item) {
      const style = { ...(this.itemStyle ?? { minWidth: 0 }) }
      const width = item.placeholder?.style?.width?.value

      const visibleLayoutItemCount = Math.max(this.visibleControlItems.length, 1)
      const gap = 'var(--ae-experimental-form-column-gap, calc(var(--ae-form-gap, 0.65rem) * 0.75))'

      if (width) {
        const percentageWidth = this.getPercentageWidth(width)
        const widthValue = percentageWidth == null ? width : `${percentageWidth}%`

        if (this.hasFixedWidthItems && percentageWidth != null) {
          style.flex = `${percentageWidth} 1 0`
          style.width = 'auto'
          style.maxWidth = 'none'
          return style
        }

        const flexBasis = percentageWidth == null
          ? widthValue
          : visibleLayoutItemCount > 1
          ? `calc(${widthValue} - (${gap} * ${visibleLayoutItemCount - 1} / ${visibleLayoutItemCount}))`
          : widthValue

        style.flex = `0 0 ${flexBasis}`
        style.width = flexBasis
        style.maxWidth = flexBasis
      }

      if ((!width || this.getPercentageWidth(width) != null) && this.visibleControlItems.length === 1) {
        style.flex = '1 1 100%'
        style.width = '100%'
        style.maxWidth = '100%'
      }

      return style
    },
    getPercentageWidth(width) {
      if (/^\d+(\.\d+)?%?$/.test(width)) {
        return Number(width.replace('%', ''))
      }

      return null
    },
    getTextStyle(item) {
      if (item.markdown?.trim().length === 0) {
        return { display: 'none' }
      }

      return {
        flex: '1 1 100%',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
      }
    },
  },
  computed: {
    type() {
      return this.paragraph?.type
    },
    items() {
      return (this.paragraph?.items) ?? []
    },
    visibleItems() {
      return this.items.filter(item => item.isVisible !== false)
    },
    visibleControlItems() {
      return this.visibleItems.filter(item => item.type === 'FIELD' || item.type === 'STANDALONE_CONTROL')
    },
    hasFixedWidthItems() {
      return this.visibleControlItems.some(item => {
        const width = item.placeholder?.style?.width?.value
        return width && this.getPercentageWidth(width) == null
      })
    },
    freeFlexWeight() {
      if (!this.hasFixedWidthItems) {
        return 0
      }

      const usedFlexibleWeight = this.visibleControlItems.reduce((sum, item) => {
        const width = item.placeholder?.style?.width?.value
        const percentageWidth = width && this.getPercentageWidth(width)
        return percentageWidth == null ? sum : sum + percentageWidth
      }, 0)

      return Math.max(0, 100 - usedFlexibleWeight)
    },
    freeFlexSpacerStyle() {
      return {
        flex: `${this.freeFlexWeight} 1 0`,
        minWidth: 0,
        maxWidth: '100%',
        pointerEvents: 'none',
      }
    },
    paragraphStyle() {
      return {
        '--ae-form-visible-layout-items': this.visibleControlItems.length,
        '--ae-form-free-flex-weight': this.freeFlexWeight,
      }
    },
  },
}
